'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteRelationView', ['Session', 'Users', 'PositionsStore', 'WorkPeriods', '$compile', '$q', 'TimeService', '$timeout', function(Session, Users, PositionsStore, WorkPeriods, $compile, $q, TimeService, $timeout) {

      var datesTpl = '<div class="date-edit-container">' +
        '<div class="date-edit-label">What date would you like to attach this note to?</div>' +
        '<div class="date-edit-content">' +
          '<div class="date-edit-toggle-row clearfix">' +
            '<div class="date-edit-toggle-label">Attachment Type</div>' +
            '<div class="date-edit-toggle-wrapper">' +
              '<div class="switch-toggle switch-4 switch-candy switch-candy-gray">' +
                '<input id="daterange4" name="view3" type="radio" value="4" data-ng-model="form.dateType">' +
                '<label for="daterange4" onclick="">Now</label>' +

                '<input id="whole1" name="view3" type="radio" value="1" data-ng-model="form.dateType">' +
                '<label for="whole1" onclick="">A Date</label>' +

                '<input id="part2" name="view3" type="radio" value="2" data-ng-model="form.dateType">' +
                '<label for="part2" onclick="">Date Range</label>' +

                '<input id="daterange3" name="view3" type="radio" value="3" data-ng-model="form.dateType">' +
                '<label for="daterange3" onclick="">Indefinite</label>' +

                '<a></a>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="sa-note-relation-view-date-description" ng-bind="dateDescription"></div>' +
          '<div class="datepicker-row" ng-if="form.dateType != 4">' +
            '<div class="start-date-picker sa_datepicker square input-prepend">' +
              '<span>{{form.dateType === \'1\' ?  \'On\' : \'From\' }}</span>' +
              '<button class="add-on" data-ng-click="openDatepicker(\'start\', $event)" style="box-sizing: border-box;">' +
                '<i class="sa-icon-cal"></i>' +
              '</button>' +
              '<input id="start-date-picker" type="text" class="form-control sa_datepicker_input" style="width:120px;box-sizing:border-box;" readonly ' +
                'uib-datepicker-popup="EEE, MM/dd/yyyy" data-ng-focus="openDatepicker(\'start\', $event)" ' +
                'data-ng-model="form.start_date" is-open="pickers.start.open" ' +
                'show-button-bar="false" datepicker-options="pickers.options">' +
            '</div>' +

            '<div class="end-date-picker sa_datepicker square input-prepend" ng-if="form.dateType === \'2\'">' +
              '<span>Through</span>' +
              '<button class="add-on" data-ng-click="openDatepicker(\'end\', $event)" style="box-sizing: border-box;">' +
                '<i class="sa-icon-cal"></i>' +
              '</button>' +
              '<input id="end-date-picker" type="text" class="form-control sa_datepicker_input" style="width:120px;box-sizing:border-box;" readonly ' +
                'uib-datepicker-popup="EEE, MM/dd/yyyy" data-ng-focus="openDatepicker(\'end\', $event)" ' +
                'data-ng-model="form.end_date" is-open="pickers.end.open" ' +
                'show-button-bar="false" datepicker-options="pickers.options">' +
            '</div>' +
            '<div class="indefinite-text" ng-if="form.dateType === \'3\'">into the future</div>' +
          '</div>' +
        '</div>' +
      '</div>';


      return {
        template: '<div class="sa-note-relation-view">' +
          '<div class="sa-note-relation-segments-container"></div>' +
          '<div class="sa-note-relation-edit-container closed"></div>' +
        '</div>',
        restrict: 'A',
        scope: {
          relations: '=',
          editable: '@'
        },
        require: '?^saNoteCreate',
        controllerAs: 'RelationView',
        link: function(scope, elem, attrs, parentCtrl) {
          scope.data = {};
          scope.state = {
            isEditable: scope.editable === 'true',
            editableEntities: [],
            isEditOpen: false
          };

          var editableScope;

          if (scope.state.isEditable) {
            console.log('saNoteCreate is editable');
          }

          // Templates
          var templates = {
            User: '<div sa-profile-picture="::data.user" size="super_tiny"></div><a user-link="::data.user" link="true">{{::data.user.first_name}} {{::data.user.last_name}}</a>',
            Position: '<span class="sa-note-relation-symbol"></span><span class="sa-note-relation-label"><a href="{{::data.position.url}}">{{::data.position.name}}</a></span>',
            WorkPeriod: '<span class="sa-note-relation-symbol"><i class="icon-building"></i></span><span class="sa-note-relation-label"><span class="position-name">&nbsp;{{::data.wp.position.name}}&nbsp;</span> <span class="datetime" ng-bind-html="::data.minInterval.strings.htmlInterval"></span></span>',
            Dates: '<span class="sa-note-relation-symbol"><i class="sa-icon-cal-blackout-1"></i></span><span class="sa-note-relation-label" ng-bind-html="data.dates.html"></span>',
            OpenEndedDate: '<span class="sa-note-relation-symbol"><i class="sa-icon-cal-blackout-1"></i></span><span class="sa-note-relation-label">From <span class="the-date">{{::data.dates.startFormatted}}</span> on</span>',
            Reply: '<span class="sa-note-relation-symbol"><i class="icon-mail-reply"></i></span><span class="sa-note-relation-label">Attached as a reply</span>'
          };

          function setSegments(html) {
            $(elem).find('.sa-note-relation-view .sa-note-relation-segments-container').html(html);
          };

          // First, it it's a reply, we're already done.
          if (parentCtrl && parentCtrl.note && !!parentCtrl.note.parent_id) {
            setContent('<div>' + templates['Reply'] + '</div>');
            return;
          }

          // Otherwise, we'll need some extra stuff
          var fetchers = {
            User: Users.getById,
            Position: PositionsStore.getRecordById,
            WorkPeriod: WorkPeriods.getById
          };

          var configurators = {
            Position: function(position) {
              position.url = '#/organizationProfile/' + position.organization_id + '/positions/' + position.id;
              scope.data.position = position;
              return scope.data.position;
            },
            Dates: function(relation) {
              scope.data.dates = {};

              if (relation.start_date.isSame(relation.end_date, 'minutes')) {
                scope.data.dates.html = relation.start_date.format('ddd, MMM D, YYYY h:mma').slice(0, -1);
              } else {
                var min = TimeService.minimalIntervalTimeFormat(moment(relation.start_date).twix(moment(relation.end_date)), undefined, 'ddd, MMM D');
                scope.data.dates.html = min.strings.htmlInterval;
              }

            },
            OpenEndedDate: function(relation) {
              scope.data.dates = {};
              scope.data.dates.startFormatted = relation.start_date.format('ddd, MMM D, YYYY');
            },
            WorkPeriod: function(wp) {
              scope.data.wp = wp;
              scope.data.minInterval = TimeService.minimalIntervalTimeFormat(moment(wp.start_time).twix(moment(wp.end_time)), undefined, 'ddd, M/D');
              return scope.data.wp;
            },
            User: function(user) {
              scope.data.user = user;
              return scope.data.user;
            }
          };

          var active_relation;

          function init() {

            // All relations are imported from the parent note.
            // Copy the active relation into it's own object.
            active_relation = lodash(scope.relations).filter({active: true}).first();
            var segments = [];

            if (!lodash.isNull(active_relation.obj)) {
              if (active_relation.obj === 'WorkPeriod') {
                segments.push({
                  type: 'WorkPeriod'
                });
              } else if (active_relation.obj === 'Position') {
                segments.push({
                  type: 'Position'
                });
              } else if (active_relation.obj === 'User') {
                segments.push({
                  type: 'User'
                });
              }
            }

            if (active_relation.start_date && active_relation.end_date && active_relation.obj !== 'WorkPeriod') {
              segments.push({
                type: 'Dates'
              });

              scope.state.editableEntities.push('dates');
            }

            if (active_relation.start_date && !active_relation.end_date && active_relation.range_twix) {
              segments.push({
                type: 'OpenEndedDate'
              });

              scope.state.editableEntities.push('dates');
            }

            var fetcherPromises = [];

            lodash.each(segments, function(segment) {
              if (segment.type in fetchers) {
                fetcherPromises.push(fetchers[segment.type](active_relation.obj_id));
              } else {
                var def = $q.defer();
                def.resolve(active_relation);
                fetcherPromises.push(def.promise);
              }
            });

            $q.all(fetcherPromises)
              .then(function(results) {
                var content = [];
                lodash.each(segments, function(segment, idx) {
                  var result = results[idx];
                  if (segment.type in templates) {
                    if (segment.type in configurators) {
                      configurators[segment.type](result);
                    }
                    content.push($compile('<div class="sa-note-relation-segment ' + lodash.kebabCase(segment.type) + '">' + templates[segment.type] + '</div>')(scope));
                  } else {
                    console.warn(segment.type + ": note relation type not recognized");
                  }
                });

                if (scope.state.isEditable && scope.state.editableEntities.length > 0) {
                  content.push($compile('<div class="sa-note-relation-edit-btn" ng-click="toggleEdit()">{{ state.isEditOpen ? \'Close\' : \'Edit\' }}</div>')(scope));
                }

                console.log(content);

                setSegments(content);

              }, function() {

              });
          }


          if (scope.state.isEditable) {
            scope.$on('sa:saNoteRelationView:update', function() {
              console.log('sa:saNoteRelationsView:update');

              // this timeout is here because... well, we really don't know.
              // angular needed one more digest cycle to propagate scope.relations
              // to saNoteRelationView
              $timeout(function() { init(); }, 0);
            });

            scope.$on('saNoteCreate:createSuccessful', function() {
              scope.state.isEditOpen = false;

              $timeout(function() { init(); }, 0);
            });

            scope.$on('$destroy', function() {
              if (editableScope) {
                // editableScope.$destroy();
                editableScope = undefined;
              }
            });

            scope.toggleEdit = function() {
              console.log('toggleEdit!');
              if (!scope.state.isEditOpen) {
                scope.state.isEditOpen = true;
                editableScope = scope.$new();

                editableScope.pickers = {
                  options: {
                    startingDay: Session.getStartOfWeekDay(),
                    showWeeks: false
                  },
                  start: {
                    open: false,
                  },
                  end: {
                    open: false
                  }
                };

                editableScope.openDatepicker = function(pickerName) {
                  editableScope.pickers[pickerName].open = !editableScope.pickers[pickerName].open;
                };

                editableScope.form = {
                  start_date: TimeService.momentToDateInLocalOffset(active_relation.start_date)
                };

                var endTwix = TimeService.getDayTwixFromDate(active_relation.end_date);

                if (active_relation.end_date) {
                  if (active_relation.start_date.format('MM/DD') === moment(active_relation.end_date).subtract(12, 'hours').format('MM/DD')) {

                    if (active_relation.start_date.isSame(active_relation.end_date, 'seconds')) {
                      editableScope.form.dateType = '4';
                      editableScope.form.end_date = TimeService.momentToDateInLocalOffset(active_relation.end_date);

                    } else {
                      editableScope.form.dateType = '1';
                      editableScope.form.end_date = TimeService.momentToDateInLocalOffset(TimeService.getBeginningOfDayFromDate(moment(active_relation.end_date).subtract(12, 'hours')));
                    }
                  } else {
                    editableScope.form.dateType = '2';
                    editableScope.form.end_date = TimeService.momentToDateInLocalOffset(TimeService.getBeginningOfDayFromDate(moment(active_relation.end_date).subtract(12, 'hours')));
                  }

                } else {
                  editableScope.form.end_date = null;
                  editableScope.form.dateType = '3';
                }

                editableScope.save = function() {
                  console.log('save!!!');
                };

                var tpl = '';

                if (lodash.includes(scope.state.editableEntities, 'dates')) {
                  tpl += datesTpl;
                }

                function genUpdateData() {
                  var data = {};

                  if (editableScope.form.dateType === '4') {
                    data.start_date = TimeService.getNowInStoreTime();
                    data.end_date = data.start_date;

                  } else if (editableScope.form.dateType === '3') {
                    data.start_date = TimeService.getBeginningOfDayFromDate(editableScope.form.start_date);
                    data.end_date = null;

                  } else if (editableScope.form.dateType === '2') {
                    data.start_date = TimeService.getBeginningOfDayFromDate(editableScope.form.start_date);
                    data.end_date = TimeService.getBeginningOfDayFromDate(moment(editableScope.form.end_date).add(36, 'hours'));

                  } else if (editableScope.form.dateType === '1') {
                    data.start_date = TimeService.getBeginningOfDayFromDate(editableScope.form.start_date);
                    data.end_date = TimeService.getBeginningOfDayFromDate(moment(editableScope.form.start_date).add(36, 'hours'));
                  }

                  return data;
                }

                editableScope.$watch('form', function() {
                  if (editableScope.form.dateType === '1') {
                    editableScope.dateDescription = 'I want this note to be associated with ' + moment(editableScope.form.start_date).format('MM/DD/YYYY') + '.';
                  } else if (editableScope.form.dateType === '2') {
                    console.log(editableScope.form);
                    if (lodash.isNull(editableScope.form.end_date)) {
                      editableScope.form.end_date = TimeService.momentToDateInLocalOffset(TimeService.getBeginningOfDayFromDate(moment(editableScope.form.start_date).add(2, 'days')));
                    }

                    editableScope.dateDescription = 'I want this note to be associated with ' + moment(editableScope.form.start_date).format('MM/DD/YYYY') + ' through ' + moment(editableScope.form.end_date).format('MM/DD/YYYY') + '.';
                  } else if (editableScope.form.dateType === '3') {
                    editableScope.dateDescription = 'I want this note to be shown from ' + moment(editableScope.form.start_date).format('MM/DD/YYYY') + ' on, until I remove it or add an end date.';
                  } else if (editableScope.form.dateType === '4') {
                    editableScope.dateDescription = 'Write a note about a situation right now. Attach a note to today, at this exact time.';
                  }

                  parentCtrl.updateRelation(genUpdateData());
                }, true);

                $(elem).find('.sa-note-relation-edit-container').html($compile(tpl)(editableScope));

                $timeout(function() {
                  $(elem).find('.sa-note-relation-edit-container').removeClass('closed');
                }, 100);
              } else {
                editableScope.$destroy();
                $(elem).find('.sa-note-relation-edit-container').addClass('closed');
                scope.state.isEditOpen = false;

                $timeout(function() {
                  $(elem).find('.sa-note-relation-edit-container').empty();
                }, 350);
              }
            };
          }

          init();
        }
      };
    }]);
